// DIJANA oleh scripts/write-version.js (prebuild). Jangan edit manual.
export const BUILD_ID = "412975a";
